const EntradaPlaceholder = ({ width, height }) => {
  return (
    <div className="row border p-3 mb-1" style={{ borderRadius: "10px" }}>
      <div className="col-md-6">
        <span className="Grifter"></span>
        <span className="d-block Grifter" style={{ fontSize: "10px" }}>
        </span>
        <div
          className="w-100 box-evento-hover border overflow-hidden border placeholder-wave mb-2"
          style={{
            borderRadius: "0px",
            width: "",
            height: "15px",
          }}
          aria-hidden="true"
        >
          <span
            class="placeholder w-100 d-block "
            style={{ height: "100px", background: "#c6c6c6" }}
          ></span>
        </div>
        <div
          className="w-100 box-evento-hover border overflow-hidden border placeholder-wave mb-2"
          style={{
            borderRadius: "0px",
            width: "",
            height: "15px",
          }}
          aria-hidden="true"
        >
          <span
            class="placeholder w-100 d-block "
            style={{ height: "100px", background: "#c6c6c6" }}
          ></span>
        </div>
      </div>
      <div className="col-md-6 text-center">
        <div
          className="w-100 box-evento-hover border overflow-hidden border placeholder-wave mb-2"
          style={{
            borderRadius: "0px",
            width: "",
            height: "100px",
          }}
          aria-hidden="true"
        >
          <span
            class="placeholder w-100 d-block"
            style={{ height: "100px", background: "#c6c6c6" }}
          ></span>
        </div>
        <div
          className="w-100 box-evento-hover border overflow-hidden border placeholder-wave"
          style={{
            borderRadius: "0px",
            width: "",
            height: "15px",
          }}
          aria-hidden="true"
        >
          <span
            class="placeholder w-100 d-block"
            style={{ height: "100px", background: "#c6c6c6" }}
          ></span>
        </div>
      </div>
    </div>
  );
};

export default EntradaPlaceholder;
